module.exports = __webpack_public_path__ + "img/elo.1495d64d.png";